import { render, staticRenderFns } from "./initPush.vue?vue&type=template&id=6643e1d6&scoped=true"
import script from "./initPush.vue?vue&type=script&lang=js"
export * from "./initPush.vue?vue&type=script&lang=js"
import style0 from "./initPush.vue?vue&type=style&index=0&id=6643e1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6643e1d6",
  null
  
)

export default component.exports